import type { ApiClient } from '../../../shared/api/api-client';
import { useOrgTimezone } from '../../../shared/lib/use-org-timezone';

/**
 * Эффективная таймзона расписания текущей организации (+branch override).
 * Делегирует общему хуку штаба (единый источник tz для рендера времени).
 */
export function useOrgScheduleTimezone({ apiClient, organizationId, branchId }: {
  apiClient: ApiClient;
  organizationId: number | null;
  branchId: number | null;
}): string {
  return useOrgTimezone({ apiClient, organizationId, branchId });
}